import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { TabsComponentModule } from '../tabs/tabs.module';
import { ElementsModule } from '@shared/elements/elements.module';
import { ContextBarModule } from '@components/context-bar/context-bar.module';

@NgModule({
    imports: [
      CommonModule,
      TabsComponentModule,
      ElementsModule,
      ContextBarModule
    ],
    exports: [
      ModalComponent
    ],
    declarations: [
      ModalComponent
    ],
    providers: [],
})
export class ModalComponentModule {
}
